const initializedRotators = new WeakSet();
const TRANSITION_DURATION = 1150;
const ENTER_DELAY = 160;
const ROW_DELAY = 100;
const REEL_TRANSFORMS = {
  entering: 'translate3d(0, 32%, 0) rotateX(-32deg) scale(.96)',
  current: 'translate3d(0, 0, 0) rotateX(0)',
  leaving: 'translate3d(0, -30%, 0) rotateX(30deg) scale(.98)',
};

const getWords = (value) => value.trim().split(/\s+/).filter(Boolean);

const setReelState = (item, state) => {
  item.style.opacity = state === 'current' ? '1' : '0';
  item.style.transform = REEL_TRANSFORMS[state];
};

const createRotatorItem = (text, type) => {
  const item = document.createElement('span');

  item.className = `first-sec__rotator-item first-sec__rotator-item--${type}`;
  item.dataset.heroRotatorItem = type;
  item.textContent = text;
  item.style.position = 'absolute';
  item.style.top = '.28em';
  item.style.left = '-.09em';
  item.style.width = 'calc(100% + .09em)';
  item.style.boxSizing = 'border-box';
  item.style.lineHeight = '1.05em';
  item.style.transformOrigin = '50% 100%';
  item.style.backfaceVisibility = 'hidden';
  item.style.transition = 'transform 1.15s cubic-bezier(0.22, 0.61, 0.36, 1), opacity .6s ease-out';
  item.style.willChange = 'transform, opacity';
  setReelState(item, 'entering');

  if (type === 'gradient') {
    item.style.paddingRight = '4px';
    item.style.paddingBottom = '.1em';
    item.style.background = 'linear-gradient(90deg, #00B1C3 0%, #04656e 100%)';
    item.style.webkitBackgroundClip = 'text';
    item.style.webkitTextFillColor = 'transparent';
    item.style.backgroundClip = 'text';
    item.style.color = 'transparent';
  }

  return item;
};

const splitPhrase = (phrase) => {
  const [primary, ...gradientWords] = getWords(phrase);

  return { primary, gradient: gradientWords.join(' ') };
};

const initHeroRotators = (scope = document) => {
  scope.querySelectorAll('[data-hero-rotator]').forEach((rotator) => {
    if (initializedRotators.has(rotator)) {
      return;
    }

    initializedRotators.add(rotator);

    const source = document.getElementById(rotator.dataset.heroRotatorSource);
    const phrases = Array.from(source?.querySelectorAll('li') || [])
      .map((item) => item.textContent || '')
      .map((item) => item.trim())
      .filter((item) => getWords(item).length > 1);
    const rows = ['primary', 'gradient'].map((name) => {
      const element = rotator.querySelector(`[data-hero-rotator-row="${name}"]`);
      const activeItem = element?.querySelector('[data-hero-rotator-item]');

      return { name, element, activeItem };
    });

    if (!phrases.length || rows.some(({ element, activeItem }) => !element || !activeItem)) {
      return;
    }

    const activeItems = new Map();
    const firstPhrase = splitPhrase(phrases[0]);

    rows.forEach(({ name, activeItem }) => {
      const firstItem = createRotatorItem(firstPhrase[name], name);

      firstItem.classList.add('is-current');
      setReelState(firstItem, 'current');
      activeItem.replaceWith(firstItem);
      activeItems.set(name, firstItem);
    });

    if (
      phrases.length < 2 ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    let index = 0;

    window.setInterval(() => {
      index = (index + 1) % phrases.length;
      const phrase = splitPhrase(phrases[index]);

      rows.forEach(({ name, element }, rowIndex) => {
        window.setTimeout(() => {
          const outgoingItem = activeItems.get(name);
          const nextItem = createRotatorItem(phrase[name], name);

          element.append(nextItem);

          requestAnimationFrame(() => {
            outgoingItem.classList.remove('is-current');
            outgoingItem.classList.add('is-leaving');
            outgoingItem.style.transition = 'transform 1.15s cubic-bezier(0.22, 0.61, 0.36, 1), opacity .35s ease-out';
            setReelState(outgoingItem, 'leaving');

            window.setTimeout(() => {
              nextItem.classList.add('is-current');
              setReelState(nextItem, 'current');
            }, ENTER_DELAY);
          });

          window.setTimeout(() => outgoingItem.remove(), TRANSITION_DURATION);
          activeItems.set(name, nextItem);
        }, rowIndex * ROW_DELAY);
      });
    }, 3500);
  });
};

initHeroRotators();
